import React, { createContext, memo, PropsWithChildren, useMemo } from 'react';

export type RuntimeContextProps = {
  modalRoot: HTMLElement;
};

export const RuntimeContext = createContext<RuntimeContextProps>({
  modalRoot: document.createElement('div'),
});

export const RuntimeProvider = memo(({ modalRoot, children }: PropsWithChildren<RuntimeContextProps>) => {
  const value = useMemo(() => ({
    modalRoot,
  }), [modalRoot]);

  return (
    <RuntimeContext.Provider value={value}>
      {children}
    </RuntimeContext.Provider>
  );
});
